<template>
  <v-list-item>
    <v-list-item-content>
      <v-select
        v-model="currentLang"
        :hint="currentLang"
        :items="langs"
        item-text="name"
        item-value="short"
        label="Seclect language"
        persistent-hint
        prepend-icon="mdi-web"
        return-object
        outlined
        single-line
      ></v-select>
    </v-list-item-content>
  </v-list-item>

  <!-- 
  <div class="locale-changer">
    <select v-model="current">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
   
      </option>
    </select>
  </div> -->
</template>

<script>
import VueCookies from "vue-cookies";

export default {
  name: "change-languages",
  data() {
    return {
      langs: [
        { name: "English", short: "en" },
        // { name: "Deutsch", short: "de" },
        { name: "Arabic", short: "ar" },
        // { name: "French", short: "fr" },
      ],
    };
  },
  computed: {
    currentLang: {
      get() {
        return this.$i18n.locale;
      },
      set(val) {
        VueCookies.set("lang", val.short);
        this.$i18n.locale = val.short;
        if (val.short == "ar") this.$vuetify.rtl = true;
        else this.$vuetify.rtl = false;
      },
    },
  },
};
</script>
